import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import Ink from "react-ink";

import {
  imageToDataURL,
  isNetworkRequestFailedError,
} from "../../config/helpers";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import mpAction from "../../redux/microPensionDublicated/action";
import InputComp from "../../component/InputComp/InputComp";

class Signature extends Component {
  state = {
    signatureImageError: "",
  };

  componentDidMount() {
    const { customRef } = this.props;

    customRef({ validate: this.validate });
  }

  validate = () => {
    const { signatureImage } = this.props;

    let isValidated = true,
      signatureImageError;

    if (!signatureImage) {
      signatureImageError = "signature Image is required";
      isValidated = false;
    }

    this.setState({
      signatureImageError,
    });

    return isValidated;
  };

  handleOnChange = async (e) => {
    const { setSignatureField, setAlertMessage } = this.props;

    try {
      if (e.target.files[0]) {
        const response = await imageToDataURL(e.target.files[0]);
        setSignatureField(response);
      }
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.handleOnChange(e)
          : null,
      });
    }
  };

  render() {
    const { signatureImage } = this.props;
    const { signatureImageError } = this.state;

    return (
      <div>
        <input
          onChange={this.handleOnChange}
          style={{ display: "none" }}
          type="file"
          id="signatureImage"
        />
        <Row className="flex1">
          <Col lg={9} md={9} sm={6} className="p-0">
            <InputComp
              disabled={true}
              type="text"
              errorMessage={signatureImageError}
              placeholder="Signature"
              containerStyles={{ width: "100%" }}
            />
          </Col>
          <Col lg={3} md={3} sm={6} className="mx-auto pl-0 pl-sm-3 pr-0">
            <label className="browser-btn-container" htmlFor="signatureImage">
              <span className="btn browse-btn">
                Browse
                <Ink />
              </span>
            </label>
          </Col>
        </Row>
        {!!signatureImage && (
          <div className="text-center my-2">
            <img alt="signatureImage" width="300px" src={signatureImage} />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  signatureImage: state.microPensionDublicated.signatureImage,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setSignatureField: mpAction.setSignatureField,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Signature);
